import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/unidade";

/**
 * Classe de gerenciamento de chamadas da API do ProcedimentoPlanoOperadora
 *
 * @class
 */
export default class UnidadeApi {
  /**
   * Instância da dependência da API (ofetch)
   */
  private api;

  /**
   * Cria uma nova instância da classe UnidadeApi.
   * @constructor
   * @param api - Instância da dependência da API (ofetch).
   */
  constructor(api: $Fetch) {
    this.api = api;
  }

  /**
 * @returns registro da unidade
 */
  BuscarTodasUnidades() {
    return this.api<ApplicationModule[]>(`${controller}/listar-combo`, {
      method: "GET",
      params: {}
    });
  }

}